import config, { getCurrentTheme } from './config';
import actions from './actions';

const initState = {
  isActivated: false,
  theme: getCurrentTheme()
};

export default function(state = initState, action) {
  switch (action.type) {
    case actions.SWITCH_ACTIVATION:
      return {
        ...state,
        isActivated: !state.isActivated,
      };
    case actions.CHANGE_THEME:
      return {
        ...state,
        theme: getCurrentTheme()
      };
    default:
      return state;
  }
}
